import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const FrenchPolynesiaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15774'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15774)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 3.73333H20V0H0V3.73333Z'
					fill='#D82332'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14.0001H20V10.2667H0V14.0001Z'
					fill='#D82332'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.33403 7.52686L9.13086 7.71254C9.31453 7.76305 9.56933 7.70426 9.67077 7.52686H9.33403Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.69531 7.65328C7.8328 7.78801 8.06054 7.77228 8.19803 7.687C8.3356 7.60165 8.43666 7.59623 8.52237 7.60518C8.53144 7.68121 8.5517 7.77868 8.58647 7.87502H7.77082C7.75057 7.82565 7.71103 7.71056 7.69531 7.65328Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.8457 8.01335C8.00579 7.93921 8.16944 7.998 8.24026 8.05144C8.37102 8.15027 8.58705 8.12347 8.69302 8.0674C8.73346 8.13205 8.78259 8.19565 8.84185 8.2442H7.96913C7.93368 8.18813 7.85704 8.05031 7.8457 8.01335Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.6412 8.62745C11.6795 8.58928 11.7314 8.52644 11.7652 8.48157C11.7088 8.4748 11.6433 8.43483 11.5736 8.40074C11.4451 8.33781 11.3222 8.33781 11.2129 8.41195C11.0506 8.52192 10.8476 8.54887 10.6898 8.4389C10.5166 8.31817 10.3562 8.34459 10.2209 8.42098C10.0856 8.49723 9.99993 8.50175 9.91875 8.50175C9.83757 8.50175 9.75193 8.49723 9.61663 8.42098C9.48134 8.34459 9.32087 8.31817 9.1477 8.4389C8.98988 8.54887 8.78693 8.52192 8.62465 8.41195C8.51527 8.33781 8.39245 8.33781 8.26388 8.40074C8.19411 8.43483 8.12865 8.4748 8.07227 8.48157C8.10613 8.52644 8.15798 8.58928 8.1963 8.62745H11.6412Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.2197 9.00285C11.2558 8.98042 11.355 8.90635 11.4046 8.86819C11.3505 8.87941 11.2271 8.84004 11.1634 8.80752C10.9785 8.71321 10.8568 8.72224 10.7193 8.79405C10.5817 8.86593 10.3878 8.90409 10.2458 8.82777C10.1038 8.75145 10.0023 8.7312 9.92789 8.7312C9.85352 8.7312 9.752 8.75145 9.60998 8.82777C9.46795 8.90409 9.27407 8.86593 9.13651 8.79405C8.99902 8.72224 8.87732 8.71321 8.69237 8.80752C8.62865 8.84004 8.50529 8.87941 8.45117 8.86819C8.50076 8.90635 8.6 8.98042 8.63605 9.00285H11.2197Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4051 8.25644C10.3668 8.23626 10.3219 8.18922 10.2811 8.12886C10.2157 8.03229 10.112 7.97839 9.95641 7.97839C9.80086 7.97839 9.69715 8.03229 9.63177 8.12886C9.59088 8.18922 9.54606 8.23626 9.50781 8.25644H10.4051Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.1511 7.90992C10.1353 7.88298 10.1016 7.79762 10.0903 7.75269C10.0542 7.76398 9.98433 7.76842 9.94374 7.76842C9.90315 7.76842 9.8333 7.76398 9.79717 7.75269C9.78591 7.79762 9.75213 7.88298 9.73633 7.90992H10.1511Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.5262 7.52686L10.7294 7.71254C10.5457 7.76305 10.2909 7.70426 10.1895 7.52686H10.5262Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.2134 7.65328C12.0759 7.78801 11.8482 7.77228 11.7107 7.687C11.5731 7.60165 11.4721 7.59623 11.3864 7.60518C11.3772 7.68121 11.357 7.77868 11.3223 7.87502H12.1379C12.1582 7.82565 12.1976 7.71056 12.2134 7.65328Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.0918 8.01335C11.9318 7.93921 11.7681 7.998 11.6973 8.05144C11.5665 8.15027 11.3505 8.12347 11.2445 8.0674C11.2041 8.13205 11.155 8.19565 11.0957 8.2442H11.9684C12.0039 8.18813 12.0806 8.05031 12.0918 8.01335Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.8273 9.15006C10.5539 9.26116 10.2547 9.3225 9.94116 9.3225C9.62733 9.3225 9.32831 9.26124 9.05469 9.14991C9.11327 9.14321 9.19089 9.11506 9.25348 9.08036C9.35499 9.02421 9.5398 9.013 9.62778 9.06915C9.71569 9.1253 9.82166 9.18137 9.94116 9.18137C10.0607 9.18137 10.1666 9.1253 10.2545 9.06915C10.3424 9.013 10.5273 9.02421 10.6288 9.08036C10.6913 9.11506 10.7686 9.14336 10.8273 9.15006Z'
					fill='#064A89'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4457 4.7088C9.95195 4.60779 9.50781 4.66613 9.50781 5.12865C9.50781 5.58215 9.50781 6.25565 9.50781 6.3949C9.50781 6.53407 9.51061 6.55169 9.6769 6.59022C10.0376 6.67385 10.0714 6.68228 10.4637 6.772V5.46992C10.1571 5.4362 10.0399 5.26489 10.0399 5.0658C10.0399 4.87274 10.1751 4.74697 10.4457 4.7088Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.18124 8.2799C8.90618 8.2799 8.61759 8.0419 8.61759 7.58841C8.61759 7.13484 8.61759 6.5646 8.61759 6.46133C8.61759 6.35919 8.62916 6.34482 8.6052 6.32103C8.59114 6.30703 8.621 6.28626 8.64125 6.26601C8.67171 6.23568 8.69258 6.21046 8.65146 6.16944C8.61026 6.12849 8.6278 6.1178 8.65372 6.09206C8.67965 6.06617 8.68978 6.04043 8.66499 6.01567C8.64019 5.99098 8.63453 5.98315 8.66158 5.9562C8.68864 5.92926 8.67738 5.91804 8.65486 5.89554C8.63226 5.87311 8.6216 5.85685 8.65032 5.82825C8.67852 5.80017 8.68071 5.79565 8.71344 5.79565C8.74617 5.79565 8.81714 5.79565 8.84874 5.79565C8.88033 5.79565 8.88086 5.80521 8.85433 5.83163C8.81994 5.8658 8.80981 5.87928 8.84874 5.91804C8.88759 5.95673 8.88592 5.96968 8.86113 5.99436C8.82387 6.0314 8.80754 6.05669 8.84533 6.09432C8.88313 6.13188 8.88645 6.14874 8.85773 6.17734C8.82901 6.20594 8.82614 6.23123 8.85773 6.26262C8.88199 6.28678 8.88366 6.30086 8.88366 6.34346C8.88366 6.60058 8.88366 7.30103 8.88366 7.4941C8.88366 7.68716 9.02341 7.8039 9.28948 7.8039C9.55554 7.8039 9.64571 7.69612 9.72236 7.62431C9.67277 7.97002 9.52848 8.2799 9.18124 8.2799Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.95713 7.17841C9.99432 7.18955 10.0304 7.24345 10.0304 7.30185H10.1037C10.1037 7.25248 10.0822 7.17616 10.0434 7.12896C10.0428 7.11662 10.0411 7.10601 10.0383 7.09532C10.0654 7.0616 10.1048 7.0077 10.1037 6.95607C10.1029 6.92348 10.0642 6.92468 10.0597 6.9505C10.056 6.97173 10.0417 7.00439 10.0147 7.01561C10.0147 6.97406 9.99092 6.92468 9.95713 6.92468C9.92334 6.92468 9.89961 6.97406 9.89961 7.01561C9.87255 7.00439 9.85827 6.97173 9.85456 6.9505C9.85003 6.92468 9.81125 6.92348 9.81057 6.95607C9.80944 7.0077 9.84889 7.0616 9.87595 7.09532C9.87316 7.10601 9.87149 7.11662 9.87089 7.12896C9.83204 7.17616 9.81057 7.25248 9.81057 7.30185H9.88389C9.88389 7.24345 9.91994 7.18955 9.95713 7.17841Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.58018 7.17841C9.61737 7.18955 9.6535 7.24345 9.6535 7.30185H9.72674C9.72674 7.25248 9.70535 7.17616 9.66642 7.12896C9.66589 7.11662 9.66415 7.10601 9.66136 7.09532C9.68842 7.0616 9.72787 7.0077 9.72674 6.95607C9.72606 6.92348 9.68728 6.92468 9.68275 6.9505C9.67904 6.97173 9.66468 7.00439 9.6377 7.01561C9.6377 6.97406 9.61404 6.92468 9.58018 6.92468C9.54639 6.92468 9.52273 6.97406 9.52273 7.01561C9.49567 7.00439 9.48131 6.97173 9.47761 6.9505C9.47307 6.92468 9.43437 6.92348 9.43362 6.95607C9.43248 7.0077 9.47194 7.0616 9.499 7.09532C9.4962 7.10601 9.49454 7.11662 9.49394 7.12896C9.45508 7.17616 9.43362 7.25248 9.43362 7.30185H9.50694C9.50694 7.24345 9.54299 7.18955 9.58018 7.17841Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.20127 7.17841C9.23846 7.18955 9.27451 7.24345 9.27451 7.30185H9.34783C9.34783 7.25248 9.32637 7.17616 9.28752 7.12896C9.28691 7.11662 9.28525 7.10601 9.28245 7.09532C9.30951 7.0616 9.34897 7.0077 9.34783 6.95607C9.34708 6.92348 9.30838 6.92468 9.30384 6.9505C9.30014 6.97173 9.28578 7.00439 9.25872 7.01561C9.25872 6.97406 9.23506 6.92468 9.20127 6.92468C9.16741 6.92468 9.14375 6.97406 9.14375 7.01561C9.11669 7.00439 9.10241 6.97173 9.0987 6.9505C9.09417 6.92468 9.05539 6.92348 9.05471 6.95607C9.05358 7.0077 9.09303 7.0616 9.12009 7.09532C9.1173 7.10601 9.11556 7.11662 9.11503 7.12896C9.0761 7.17616 9.05471 7.25248 9.05471 7.30185H9.12795C9.12795 7.24345 9.16408 7.18955 9.20127 7.17841Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.336 7.17841C10.2988 7.18955 10.2628 7.24345 10.2628 7.30185H10.1895C10.1895 7.25248 10.2109 7.17616 10.2498 7.12896C10.2503 7.11662 10.2521 7.10601 10.2549 7.09532C10.2278 7.0616 10.1883 7.0077 10.1895 6.95607C10.1902 6.92348 10.2289 6.92468 10.2335 6.9505C10.2372 6.97173 10.2515 7.00439 10.2785 7.01561C10.2785 6.97406 10.3023 6.92468 10.336 6.92468C10.3699 6.92468 10.3936 6.97406 10.3936 7.01561C10.4205 7.00439 10.4349 6.97173 10.4386 6.9505C10.4431 6.92468 10.4818 6.92348 10.4826 6.95607C10.4837 7.0077 10.4443 7.0616 10.4172 7.09532C10.42 7.10601 10.4218 7.11662 10.4223 7.12896C10.4612 7.17616 10.4826 7.25248 10.4826 7.30185H10.4093C10.4093 7.24345 10.3732 7.18955 10.336 7.17841Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.713 7.17841C10.6758 7.18955 10.6397 7.24345 10.6397 7.30185H10.5664C10.5664 7.25248 10.5879 7.17616 10.6267 7.12896C10.6274 7.11662 10.629 7.10601 10.6318 7.09532C10.6048 7.0616 10.5653 7.0077 10.5664 6.95607C10.5671 6.92348 10.6059 6.92468 10.6104 6.9505C10.6141 6.97173 10.6284 7.00439 10.6555 7.01561C10.6555 6.97406 10.6792 6.92468 10.713 6.92468C10.7469 6.92468 10.7705 6.97406 10.7705 7.01561C10.7976 7.00439 10.8119 6.97173 10.8156 6.9505C10.8201 6.92468 10.8588 6.92348 10.8596 6.95607C10.8607 7.0077 10.8212 7.0616 10.7942 7.09532C10.797 7.10601 10.7986 7.11662 10.7992 7.12896C10.8382 7.17616 10.8596 7.25248 10.8596 7.30185H10.7863C10.7863 7.24345 10.7502 7.18955 10.713 7.17841Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.98047 7.37634H10.9644V7.46968H8.98047V7.37634Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.7306 8.2799C11.0056 8.2799 11.2942 8.0419 11.2942 7.58841C11.2942 7.13484 11.2942 6.5646 11.2942 6.46133C11.2942 6.35919 11.2827 6.34482 11.3066 6.32103C11.3207 6.30703 11.2908 6.28626 11.2706 6.26601C11.2401 6.23568 11.2192 6.21046 11.2604 6.16944C11.3015 6.12849 11.284 6.1178 11.2582 6.09206C11.2322 6.06617 11.222 6.04043 11.2468 6.01567C11.2716 5.99098 11.2773 5.98315 11.2502 5.9562C11.2232 5.92926 11.2344 5.91804 11.257 5.89554C11.2796 5.87311 11.2902 5.85685 11.2615 5.82825C11.2333 5.80017 11.2311 5.79565 11.1984 5.79565C11.1656 5.79565 11.0947 5.79565 11.0631 5.79565C11.0316 5.79565 11.0309 5.80521 11.0575 5.83163C11.0919 5.8658 11.102 5.87928 11.0631 5.91804C11.0242 5.95673 11.0259 5.96968 11.0507 5.99436C11.0879 6.0314 11.1042 6.05669 11.0665 6.09432C11.0287 6.13188 11.0253 6.14874 11.0541 6.17734C11.0828 6.20594 11.0857 6.23123 11.0541 6.26262C11.0298 6.28678 11.0282 6.30086 11.0282 6.34346C11.0282 6.60058 11.0282 7.30103 11.0282 7.4941C11.0282 7.68716 10.8883 7.8039 10.6223 7.8039C10.3563 7.8039 10.2662 7.69612 10.1895 7.62431C10.239 7.97002 10.3833 8.2799 10.7306 8.2799Z'
					fill='#514537'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.98047 6.77201C8.98047 6.77201 8.98054 6.70578 8.98054 6.62366L9.37714 6.77209L8.98047 6.77201Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.50659 6.84091L7.61914 6.72176C7.64492 6.53238 7.69367 6.34775 7.76381 6.172L8.50659 6.46562V6.84091Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.3398 5.38715L10.4976 4.74194C10.6822 4.7865 10.8616 4.85364 11.0317 4.94216L10.5229 5.91192L10.5247 5.42501C10.466 5.42531 10.3759 5.41635 10.3398 5.38715Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.52753 6.90401L7.62352 6.84937C7.61188 7.03814 7.62344 7.22864 7.65821 7.41659C7.65821 7.41659 8.52753 7.42201 8.52753 7.41659V6.90401Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.51834 6.29692C8.48909 6.25876 8.50715 6.23844 8.53867 6.21819C8.57027 6.19802 8.56573 6.18228 8.55001 6.15316C8.53421 6.12395 8.51842 6.09249 8.54774 6.0611C8.57707 6.02964 8.56573 6.01617 8.54321 5.99374C8.52068 5.97131 8.51842 5.94662 8.53867 5.92863C8.55901 5.91064 8.55447 5.89717 8.54102 5.87925C8.52741 5.86126 8.50088 5.82483 8.52461 5.80127L8.15583 5.49463C8.03399 5.63975 7.92968 5.79992 7.8457 5.97168L8.51834 6.29692Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.40147 6.46404L8.96194 6.0396C9.02392 5.97788 9.03012 5.9678 8.98621 5.92399C8.93828 5.87627 8.93655 5.8713 9.03405 5.77413C9.06731 5.74109 9.04871 5.71798 9.0014 5.71798C8.95408 5.71798 8.73647 5.71798 8.71168 5.71798C8.68689 5.71798 8.66738 5.71926 8.64924 5.73732L8.29883 5.39952C8.43254 5.26245 8.5819 5.14285 8.7432 5.04297L9.40147 6.09711V6.46404Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.94513 6.52862C8.94513 6.42317 8.9452 6.31877 8.9452 6.30394C8.9452 6.27248 8.94293 6.26014 8.91814 6.23545C8.89335 6.21076 8.90575 6.19894 8.92494 6.172L9.34188 6.51786V6.72093L8.94513 6.52862Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.33508 5.91245C9.33508 5.7099 9.33508 5.52256 9.33508 5.41462C9.33508 5.09134 9.3533 4.92966 9.40061 4.89715L9.36274 4.74194C9.17763 4.79155 8.99819 4.85869 8.82812 4.9472L9.33508 5.91245Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.9631 6.77201C10.9631 6.77201 10.963 6.70578 10.963 6.62366L10.5664 6.77209L10.9631 6.77201Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.3984 6.84091L12.2859 6.72176C12.2601 6.53238 12.2114 6.34775 12.1412 6.172L11.3984 6.46562V6.84091Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.3984 6.90401L12.3024 6.84937C12.314 7.03814 12.3025 7.22864 12.2677 7.41659C12.2677 7.41659 11.3984 7.42201 11.3984 7.41659V6.90401Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.3693 6.29692C11.3986 6.25876 11.3805 6.23844 11.349 6.21819C11.3174 6.19802 11.3219 6.18228 11.3376 6.15316C11.3534 6.12395 11.3692 6.09249 11.3399 6.0611C11.3106 6.02964 11.3219 6.01617 11.3444 5.99374C11.3669 5.97131 11.3692 5.94662 11.349 5.92863C11.3286 5.91064 11.3332 5.89717 11.3466 5.87925C11.3602 5.86126 11.3867 5.82483 11.363 5.80127L11.7318 5.49463C11.8536 5.63975 11.9579 5.79992 12.0419 5.97168L11.3693 6.29692Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.5664 6.46404L11.0059 6.0396C10.9439 5.97788 10.9377 5.9678 10.9817 5.92399C11.0296 5.87627 11.0313 5.8713 10.9338 5.77413C10.9005 5.74109 10.9192 5.71798 10.9665 5.71798C11.0138 5.71798 11.2314 5.71798 11.2562 5.71798C11.281 5.71798 11.3005 5.71926 11.3186 5.73732L11.6691 5.39952C11.5353 5.26245 11.386 5.14285 11.2247 5.04297L10.5664 6.09711V6.46404Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.9632 6.52862C10.9632 6.42317 10.9631 6.31877 10.9631 6.30394C10.9631 6.27248 10.9653 6.26014 10.9901 6.23545C11.0149 6.21076 11.0025 6.19894 10.9833 6.172L10.5664 6.51786V6.72093L10.9632 6.52862Z'
					fill='#EEA339'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.67773 6.32251C8.69353 6.33824 8.70033 6.3539 8.70033 6.39206C8.70033 6.43022 8.70033 7.2654 8.70033 7.5932C8.70033 7.9928 8.9438 8.21507 9.19406 8.21507C9.42399 8.21507 9.57509 8.00627 9.654 7.76383C9.55256 7.84241 9.40374 7.8671 9.26163 7.8671C9.09708 7.8671 8.8311 7.75713 8.8311 7.51913C8.8311 7.29912 8.8311 6.48411 8.8311 6.3539C8.8311 6.32251 8.7995 6.32251 8.67773 6.32251Z'
					fill='#D82332'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.1142 4.74884C9.79979 4.71715 9.50818 4.78225 9.50818 5.20933C9.50818 5.65838 9.50818 6.20612 9.50818 6.34401C9.50818 6.53346 9.49321 6.51095 9.65444 6.55077C9.94695 6.62303 9.98014 6.63221 10.3349 6.7129V5.55843C10.032 5.52538 9.9007 5.3278 9.9007 5.109C9.9007 4.9349 9.97795 4.77104 10.1142 4.74884Z'
					fill='#D82332'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.2399 6.32251C11.2241 6.33824 11.2173 6.3539 11.2173 6.39206C11.2173 6.43022 11.2173 7.2654 11.2173 7.5932C11.2173 7.9928 10.9739 8.21507 10.7236 8.21507C10.4937 8.21507 10.3426 8.00627 10.2637 7.76383C10.3652 7.84241 10.5139 7.8671 10.656 7.8671C10.8206 7.8671 11.0866 7.75713 11.0866 7.51913C11.0866 7.29912 11.0866 6.48411 11.0866 6.3539C11.0866 6.32251 11.1182 6.32251 11.2399 6.32251Z'
					fill='#D82332'
				/>
				<mask
					id='mask1_2332_15774'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='7'
					y='4'
					width='6'
					height='6'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0001 9.33329C11.3151 9.33329 12.381 8.28862 12.381 6.99996C12.381 5.71129 11.3151 4.66663 10.0001 4.66663C8.68513 4.66663 7.61914 5.71129 7.61914 6.99996C7.61914 8.28862 8.68513 9.33329 10.0001 9.33329Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15774)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M10.0001 13.0666C11.3151 13.0666 12.381 12.0219 12.381 10.7332C12.381 9.44457 11.3151 8.3999 10.0001 8.3999C8.68513 8.3999 7.61914 9.44457 7.61914 10.7332C7.61914 12.0219 8.68513 13.0666 10.0001 13.0666Z'
						fill='#064A89'
					/>
				</g>
			</g>
		</svg>
	);
};

export default FrenchPolynesiaFlagIcon;
